import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PersonalLifetimeThresholdDTO } from './personal-lifetime-thresholds.model';

@Injectable({
  providedIn: 'root',
})
export class PersonalLifetimeThresholdsService {
  constructor(private http: HttpClient) {}

  public updateDeposit(playerId: number, dto: PersonalLifetimeThresholdDTO): Observable<void> {
    return this.http.put<void>(`/player-activity/api/players/${playerId}/lifetime-deposits-threshold`, dto);
  }

  public updateNetLoss(playerId: number, dto: PersonalLifetimeThresholdDTO): Observable<void> {
    return this.http.put<void>(`/player-activity/api/players/${playerId}/lifetime-net-loss-threshold`, dto);
  }

  public getDeposit(playerId: number): Observable<PersonalLifetimeThresholdDTO> {
    return this.http.get<PersonalLifetimeThresholdDTO>(
      `/player-activity/api/players/${playerId}/lifetime-deposits-threshold`
    );
  }

  public getNetLoss(playerId: number): Observable<PersonalLifetimeThresholdDTO> {
    return this.http.get<PersonalLifetimeThresholdDTO>(
      `/player-activity/api/players/${playerId}/lifetime-net-loss-threshold`
    );
  }
}
